const { makeStyles } = require('@material-ui/core');

export const useStyles = makeStyles(() => ({
  filtersContainer: {
    display: 'flex',
    overflowX: 'auto',
  },
}));
